import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  alternateErrorMessage?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public override state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public override render() {
    if (this.state.hasError) {
      return (
        <h1>
          {this.props.alternateErrorMessage
            ? this.props.alternateErrorMessage
            : `Sorry.. there was an error: ${this.state.error?.message}`}
        </h1>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
